module.exports = "/img/chevrolet.a9217b58.png";